import ChipTag from "../../../../components/ChipTag";
import ImgOption from "../../../../components/filterOption/SeverityOption";
import FilterMenu from "../../../../components/filters/FilterMenu";
import SearchAndOrFilter from "../../../../components/filters/SearchAndOrFilter";
import LabelChip from "../../../../components/LabelChip";
import { EntityRisk, VulnerabilitySeverity } from "../../../../utils/constants";
import IntegrationRowFilter from "../../../posture/steps/components/IntegrationRowFilter";
import { IntegrationsMapping } from "../../integrations/IntegrationsMapping";
import { getCVESeverityNameFromValue, getRiskNameFromValue } from "../utils";
import { ALL_OPTION_NAME, filterName } from "./utils";

const riskOptions = [
  {
    name: ALL_OPTION_NAME,
    label: "All risk levels",
    displayName: "All Risks",
  },
  ...Object.values(EntityRisk)
    .sort()
    .reverse()
    .map((risk) => ({
      name: getRiskNameFromValue(risk),
      label: (
        <ImgOption type={"entityRisk"} label={getRiskNameFromValue(risk)} />
      ),
      displayName: getRiskNameFromValue(risk),
    })),
];

export const getSourceOptions = (fetchedEntities) => {
  const safeEntities = Array.isArray(fetchedEntities) ? fetchedEntities : [];
  const sources = new Set(safeEntities.flatMap((entity) => entity.sources));
  return [
    {
      name: ALL_OPTION_NAME,
      label: "All sources",
      displayName: "All",
    },
    ...Array.from(sources).map((source) => ({
      name: source,
      label: <IntegrationRowFilter name={source} />,
      displayName: IntegrationsMapping[source].displayName,
    })),
  ];
};

export const getRelatedAssetOptions = (assets) => {
  const safeAssets = Array.isArray(assets) ? assets : [];
  if (safeAssets.length === 0) return [];
  return [
    {
      name: ALL_OPTION_NAME,
      label: "All critical assets",
      displayName: "All",
    },
    ...safeAssets.map((asset) => ({
      name: asset.asset_id,
      label: asset.name,
      displayName: asset.name,
    })),
  ];
};

export const cveOptions = [
  {
    name: ALL_OPTION_NAME,
    label: "All severities",
    displayName: "All",
  },
  ...Object.values(VulnerabilitySeverity).map((severity) => ({
    name: getCVESeverityNameFromValue(severity),
    label: (
      <ImgOption
        type={"severity"}
        label={getCVESeverityNameFromValue(severity)}
      />
    ),
    displayName: getCVESeverityNameFromValue(severity),
    disabled: [
      VulnerabilitySeverity.MEDIUM,
      VulnerabilitySeverity.LOW,
    ].includes(severity),
  })),
];

export const getLabelOptions = (allLabels) => {
  if (allLabels.length === 0) return [];
  return [
    {
      name: ALL_OPTION_NAME,
      label: "All labels",
      displayName: "All",
    },
    ...allLabels.map((label) => ({
      name: label.label_id,
      label: (
        <LabelChip
          text={label.name}
          size="M"
          type="noBorder"
          color={label.color}
          sx={{ paddingX: "4px" }}
        />
      ),
      displayName: label.name,
    })),
  ];
};

export const getTagOptions = (allCustomTags) => {
  if (allCustomTags?.length === 0) return [];
  return [
    {
      name: ALL_OPTION_NAME,
      label: "All tags",
      displayName: "All",
    },
    ...allCustomTags.map((tag) => ({
      name: tag.tag_id,
      label: <ChipTag tagKey={tag.key} tagValue={tag.value} />,
      displayName: tag.key + ": " + tag.value,
    })),
  ];
};

export const getCustomerIDOptions = (fetchedEntities) => {
  const safeEntities = Array.isArray(fetchedEntities) ? fetchedEntities : [];
  const customerIDs = new Set(safeEntities.map((entity) => entity.customer_id));
  return [
    {
      name: ALL_OPTION_NAME,
      label: "All customer IDs",
      displayName: "All",
    },
    ...Array.from(customerIDs).map((customerID) => ({
      name: customerID,
      label: customerID,
      displayName: customerID,
    })),
  ];
};
export const getSharedFilters = (params) => [
  <FilterMenu
    filterName={"Risk"}
    fieldName={filterName.RISK}
    options={riskOptions}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
  <SearchAndOrFilter
    filterName={"Source"}
    fieldName={filterName.SOURCES}
    options={getSourceOptions(params.fetchedEntities)}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
    setFilterLogic={params.setFilterAndOrLogics}
    filterLogic={params.filterAndOrLogics[filterName.SOURCES]}
  />,
  <FilterMenu
    filterName={"Exclude Source"}
    fieldName={filterName.EXCLUDE_SOURCE}
    options={getSourceOptions(params.fetchedEntities)}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
  <SearchAndOrFilter
    filterName={"Critical Asset"}
    fieldName={filterName.RELATED_ASSETS}
    options={getRelatedAssetOptions(params.assets)}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
    setFilterLogic={params.setFilterAndOrLogics}
    filterLogic={params.filterAndOrLogics[filterName.RELATED_ASSETS]}
  />,
  <SearchAndOrFilter
    filterName={"Label"}
    fieldName={filterName.LABELS}
    options={getLabelOptions(params.allLabels)}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
    setFilterLogic={params.setFilterAndOrLogics}
    filterLogic={params.filterAndOrLogics[filterName.LABELS]}
  />,

  <SearchAndOrFilter
    filterName={"Tag"}
    fieldName={filterName.CUSTOM_TAGS}
    options={getTagOptions(params.allCustomTags)}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
    setFilterLogic={params.setFilterAndOrLogics}
    filterLogic={params.filterAndOrLogics[filterName.CUSTOM_TAGS]}
  />,
];
export const getSharedFiltersMultiTenant = (params) => [
  <FilterMenu
    filterName={"Risk"}
    fieldName={filterName.RISK}
    options={riskOptions}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
  <SearchAndOrFilter
    filterName={"Source"}
    fieldName={filterName.SOURCES}
    options={getSourceOptions(params.fetchedEntities)}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
    setFilterLogic={params.setFilterAndOrLogics}
    filterLogic={params.filterAndOrLogics[filterName.SOURCES]}
  />,
  <FilterMenu
    filterName={"Exclude Source"}
    fieldName={filterName.EXCLUDE_SOURCE}
    options={getSourceOptions(params.fetchedEntities)}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,

  <FilterMenu
    filterName={"Customer ID"}
    fieldName={filterName.CUSTOMER_ID}
    options={getCustomerIDOptions(params.fetchedEntities)}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
];
